import { PaginationHandler } from "components/DesignSystem/Pagination/Pagination";
import { Search } from "components/DesignSystem/Search/Search";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { TaskTrackerTrackerFilterType } from "./SalesTaxTracker";
import { useQuery, useUpdateQuery } from "hooks/useQuery";
import { debounce } from "utils/debouncing";
import { SalesTaxTrackerFilter } from "./SalesTaxTrackerFilter";
import { TASK_TYPE } from "store/apis/taskTrackerSalesTax";
import { Button } from "components/DesignSystem/Button/Button";

export const SalesTaxTrackerHeader = ({
  filter,
  totalPage = 0,
  itemsPerPage = 0,
  totalItemCount = 0,
  resetFilter,
  isFetching,
}: {
  filter: TaskTrackerTrackerFilterType;
  totalPage?: number;
  totalItemCount?: number;
  itemsPerPage?: number;
  resetFilter: () => void;
  isFetching: boolean;
}) => {
  const query = useQuery();
  const page = Number(query.get("page") || "1");
  const searchTerm = query.get("search_term") || null;
  const { updateMultiple } = useUpdateQuery();

  const selectedTab = query.get("tab") || TASK_TYPE.FILINGS;

  const handleSearch = debounce((e) => {
    updateMultiple([
      {
        query: "search_term",
        value: e.target.value || null,
      },
      {
        query: "page",
        value: "1",
      },
    ]);
  });
  const isAnyFilterActive = Object.values(filter.values).some((value) =>
    Array.isArray(value) ? value.length > 0 : Boolean(value)
  );
  const handleTabChange = (value: string) => {
    if (isAnyFilterActive) {
      resetFilter();
    }
    updateMultiple([
      {
        query: "tab",
        value: value,
      },
      {
        query: "page",
        value: "1",
      },
    ]);
  };
  return (
    <div className="t-flex t-flex-col t-gap-4 t-pb-4">
      <div className="t-flex t-justify-between t-items-center">
        <div className="t-flex t-gap-4 t-items-center">
          <ToggleGroup
            size="small"
            onValueChange={handleTabChange}
            value={selectedTab}
          >
            <ToggleGroupItem value={TASK_TYPE.FILINGS}>Filings</ToggleGroupItem>
            <ToggleGroupItem value={TASK_TYPE.REGISTRATIONS}>
              Registrations
            </ToggleGroupItem>
          </ToggleGroup>

          <Search
            customSize="small"
            placeholder="Search.."
            className="t-w-52"
            onChange={handleSearch}
            defaultValue={searchTerm || ""}
          />
        </div>
        <PaginationHandler
          page_num={page}
          per_page={itemsPerPage}
          total_count={totalItemCount}
          total_pages={totalPage}
          isLoading={isFetching}
          showLoadingText
        />
      </div>
      <div className="t-flex t-justify-between">
        <SalesTaxTrackerFilter filter={filter} />
        {isAnyFilterActive && (
          <Button size="xsmall" onClick={resetFilter}>
            Clear all filters
          </Button>
        )}
      </div>
    </div>
  );
};
